module.exports = __webpack_public_path__ + "static/media/peep-error.beb3b8b7.png";